<template>
	<div class="stamp-winner-register-list">
		<div class="body-scroll-table__thead-scroller">
			<table class="table-main stamp-winner-register-list__thead-table">
				<thead>
					<tr>
						<th
							v-for="item in thList"
							:key="item.id"
							:class="`stamp-winner-register-list__table-item-${item.id}`"
						>
							<input
								v-if="item.id === 'checkbox'"
								v-model="allCheckModel"
								:disabled="hasSelectOn"
								type="checkbox"
							/>
							<span v-else v-html="item.text" />
						</th>
					</tr>
				</thead>
			</table>
		</div>
		<div
			class="body-scroll-table__tbody-scroller stamp-winner-register-list__tbody-scroller"
		>
			<table class="table-main stamp-winner-register-list__tbody-table">
				<tbody>
					<tr v-for="item in list" :key="item.idRegister">
						<td
							:class="`stamp-winner-register-list__table-item-${thList[0].id}`"
						>
							<input
								v-model="checkListModel"
								:value="item.idRegister"
								:disabled="item.winner"
								type="checkbox"
							/>
						</td>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[1].id}`"
						>
							<router-link
								class="link"
								:to="`/event/stamp/${id}/register/${item.idRegister}`"
								target="_blank"
								>{{ item.idRegister }}</router-link
							>
						</td>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[2].id}`"
							v-text="item.nickName"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[3].id}`"
							v-text="item.genderName"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[4].id}`"
							v-text="item.age"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[5].id}`"
							:style="{ color: item.gradeColor }"
							v-text="item.gradeName"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[6].id}`"
						>
							<button
								class="btn"
								v-text="'카테고리등급'"
								@click="openCategoryGradeModal(item.idRegister)"
							/>
						</td>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[7].id}`"
						>
							<button
								class="btn"
								v-text="'브랜드등급'"
								@click="openBrandGradeModal(item.idRegister)"
							/>
						</td>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[8].id}`"
							v-text="item.stamp_all_cnt"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[9].id}`"
							v-text="item.stamp_normal_cnt"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[10].id}`"
							v-text="item.stamp_review_cnt"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[11].id}`"
						>
							<button
								:disabled="!item.comment_cnt"
								class="btn"
								v-text="item.comment_cnt"
								@click="openCommentModal(item.idRegister)"
							/>
						</td>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[12].id}`"
							v-text="item.userName"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[13].id}`"
							v-text="item.phone"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[14].id}`"
							v-text="item.addr"
						/>
						<td
							:class="`stamp-winner-register-list__table-item-${thList[15].id}`"
						>
							<button
								:disabled="!item.totalWinnerCnt"
								class="btn"
								v-text="item.totalWinnerCnt"
								@click="
									openEventWinnerHistoryListModal(
										item.idRegister
									)
								"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'StampWinnerRegisterList',
		props: {
			list: {
				type: Array,
				default: () => [],
			},
			hasSelectOn: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				thList: [
					{ id: 'checkbox', value: false },
					{ id: 'id-register', text: '회원번호' },
					{ id: 'nickname', text: '닉네임' },
					{ id: 'gender', text: '성별' },
					{ id: 'age', text: '나이' },
					{ id: 'grade', text: '회원등급' },
					{ id: 'cate-grade', text: '카테고리등급' },
					{ id: 'brand-grade', text: '브랜드등급' },
					{ id: 'stamp-total', text: '출석누적' },
					{ id: 'stamp', text: '일반출석' },
					{ id: 'review', text: '리뷰미션' },
					{ id: 'comment', text: '댓글' },
					{ id: 'name', text: '이름' },
					{ id: 'phone', text: '휴대폰' },
					{ id: 'addr', text: '주소' },
					{ id: 'history', text: '당첨이력' },
				],
				allCheck: false,
				checkList: [],
				id: this.$route.params.idStamp,
			};
		},
		computed: {
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(v) {
					this.allCheck = v;
					this.checkList = v
						? this.list.map(item => item.idRegister)
						: [];
					this.$emit('changeCheckListLength', this.checkList.length);
				},
			},
			checkListModel: {
				get() {
					return this.checkList;
				},
				set(v) {
					this.checkList = v;
					this.allCheck =
						v.length === this.list.length && this.list.length;
					this.$emit('changeCheckListLength', v.length);
				},
			},
		},
		methods: {
			initCheck() {
				this.allCheckModel = false;
				this.checkListModel = [];
			},
			openCategoryGradeModal(idRegister) {
				this.$store.commit('modal/toggleModal', {
					id: 'ReviewerGrade',
					contsTitle: '리뷰어 등급 - 카테고리',
					params: { id: idRegister, type: 'category' },
				});
			},
			openBrandGradeModal(idRegister) {
				this.$store.commit('modal/toggleModal', {
					id: 'ReviewerGrade',
					contsTitle: '리뷰어 등급 - 브랜드',
					params: { id: idRegister, type: 'brand' },
				});
			},
			openCommentModal(idRegister) {
				this.$store.commit('modal/toggleModal', {
					id: 'StampCommentList',
					params: { idRegister },
				});
			},
			openEventWinnerHistoryListModal(idRegister) {
				this.$store.commit('modal/toggleModal', {
					id: 'EventWinnerHistoryList',
					params: { idRegister },
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-winner-register-list {
		&__tbody-scroller {
			max-height: 400px;
		}

		&__thead-table th {
			border-top: 0;
		}

		&__thead-table,
		&__tbody-table {
			table-layout: fixed;
		}

		&__table-item-checkbox {
			width: 30px;
			padding: 0;
		}

		&__table-item-id-register,
		&__table-item-name,
		&__table-item-history {
			width: 70px;
			padding: 0;
		}

		&__table-item-nickname {
			width: 120px;
			padding: 0;
		}

		&__table-item-gender,
		&__table-item-age {
			width: 40px;
			padding: 0;
		}

		&__table-item-grade,
		&__table-item-stamp-total,
		&__table-item-stamp,
		&__table-item-review {
			width: 60px;
			padding: 0;
		}

		&__table-item-cate-grade,
		&__table-item-brand-grade {
			width: 120px;
			padding: 0;
		}

		&__table-item-comment {
			width: 80px;
			padding: 0;
		}

		&__table-item-phone {
			width: 123px;
			padding: 0;
		}

		&__certificated-phone {
			color: $btn-blue;
			font-weight: 700;
		}
	}
</style>
